import React from "react";

import loadingIconLight from "../../assets/images/loading-light.gif";

export const XboxSpinner = () => (
  <img
    aria-live="assertive"
    role="alert"
    alt="Xbox"
    src={loadingIconLight}
    tabIndex={-1}
    width={64}
    height={64}
  />
);
